// import {
//   IconStar,
//   IconStarFilled,
//   IconClose,
//   IconCheck,
//   IconPLus,
//   IconLoading,
// } from '@vuesax-plus/constants'

import { definePropType } from './props'

import type { Component } from 'vue'

export const iconPropType = definePropType<string | Component>([
  String,
  Object,
  Function,
])

// export const CloseComponents = {
//   IconClose,
// }

// export const TypeComponents = {
//   IconClose,
//   SuccessFilled,
//   InfoFilled,
//   WarningFilled,
//   CircleCloseFilled,
// }

// export const TypeComponentsMap = {
//   success: SuccessFilled,
//   warning: WarningFilled,
//   error: CircleCloseFilled,
// }

// export const ValidateComponentsMap = {
//   validating: Loading,
//   success: CircleCheck,
//   error: CircleClose,
// }
